<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.7188 4.72173C10.1402 3.71124 8.26298 3.125 6.25 3.125C5.06435 3.125 3.92454 3.32849 2.86465 3.70311C2.55247 3.81345 2.34375 4.1086 2.34375 4.43971V19.2835C2.34375 19.5371 2.46685 19.7749 2.67392 19.9213C2.88098 20.0678 3.14624 20.1046 3.38535 20.0201C4.28033 19.7037 5.24418 19.5312 6.25 19.5312C8.32814 19.5312 10.2326 20.268 11.7188 21.4955V4.72173Z"
				:fill="color" 
			/>
			<path
				d="M13.2812 21.4955C14.7674 20.268 16.6719 19.5312 18.75 19.5312C19.7558 19.5312 20.7197 19.7037 21.6147 20.0201C21.8538 20.1046 22.119 20.0678 22.3261 19.9213C22.5331 19.7749 22.6562 19.5371 22.6562 19.2835V4.43971C22.6562 4.1086 22.4475 3.81345 22.1353 3.70311C21.0755 3.32849 19.9357 3.125 18.75 3.125C16.737 3.125 14.8598 3.71124 13.2812 4.72173V21.4955Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgBook',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>